import { AlertCircle } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { ContentType } from "@/types/ab-tests";
import { getTestableFields } from "@/utils/ab-test-utils";

interface ListingFieldsSelectorProps {
  availableBulletPoints: string[];
  selectedFields: ContentType[];
  onToggle: (field: ContentType) => void;
}

export function ListingFieldsSelector({
  availableBulletPoints,
  selectedFields,
  onToggle,
}: ListingFieldsSelectorProps) {
  const availableFields = getTestableFields(availableBulletPoints.length);

  return (
    <div className="space-y-2">
      <Label>Listing fields to test</Label>
      <div className="rounded-lg border border-border bg-muted/50 p-3 space-y-2.5">
        {availableFields.map((field) => (
          <div key={field.value} className="flex items-center gap-2">
            <Checkbox
              id={`edit-field-${field.value}`}
              checked={selectedFields.includes(field.value)}
              onCheckedChange={() => onToggle(field.value)}
            />
            <label htmlFor={`edit-field-${field.value}`} className="text-sm cursor-pointer select-none">
              {field.label}
            </label>
          </div>
        ))}
      </div>
      {selectedFields.length > 1 && (
        <div className="flex items-start gap-1.5 text-xs text-amber-600 dark:text-amber-400">
          <AlertCircle className="h-3.5 w-3.5 mt-0.5 shrink-0" />
          <span>Testing multiple fields at once reduces result specificity — it becomes harder to isolate which change drove the outcome.</span>
        </div>
      )}
    </div>
  );
}
